const SvgIconYield = (props) => (
  <svg viewBox="0 0 105 105" xmlns="http://www.w3.org/2000/svg">
    <path d="M105 0v105H0L105 0Z" fill="#3763FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.63 80.37c7.128 7.129 16.976 11.537 27.854 11.537 21.755 0 39.391-17.636 39.391-39.39 0-10.879-4.409-20.726-11.537-27.855L24.63 80.37Z"
      fill="#F06C22"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.63 80.37C17.5 73.242 13.092 63.394 13.092 52.516c0-21.755 17.636-39.391 39.391-39.391 11.375 0 21.623 4.82 28.813 12.53a39.741 39.741 0 0 0-.958-.992L24.63 80.37Z"
      fill="#D3DDFF"
    />
  </svg>
);

export default SvgIconYield;
